import React, {
  useEffect,
  useState
} from 'react'
import { Provider } from 'react-redux'

const LoadingSuspense = props => <div className="CompLoading">
  { /* LOADING COMP { props.component } */ }
</div>
const LoadingError = props => <div className="CompError">
  { /* ERROR: { props.error } */ }
</div>

export default props => {

  const Loading = <LoadingSuspense { ...props } />
  const [ Comp, setComp ] = useState(Loading)

  useEffect(() => {

    const componentpath = props.component 
    const pluginName = componentpath.split('/')[0]
    const componentName = componentpath.replace(`${pluginName}/`, '');

    window.playmotiv
    .componentloader
    .load(`${ componentpath }`)
    .then(() => {

      const RegisteredComponent = window.playmotiv
      .comps[pluginName][componentName].default

      const comp = <RegisteredComponent { ...props } />

      setComp(comp)
      
    })
    .catch(error => {

      const comp = <LoadingError error={ error } />

      setComp(comp)
    })
  }, [])

  return Comp
}